/** @jsx jsx */
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import BrandFilters from './BrandFilters';

export default function ExhibitorFilters(props) {
  return <BrandFilters {...props} />;
}

export const fragment = graphql`
  fragment ExhibitorFilters on Exhibitor {
    ...BrandFilters
  }
`;
